import {
  ServiceRequestTaskCardDisplayVariant,
  ServiceRequestTaskProps,
} from '../../../types';
import { ServiceRequestDefaultTaskCard } from './ServiceRequestDefaultTaskCard';
import { ServiceRequestTaskPreview } from './ServiceRequestTaskPreview';
import { ServiceRequestTimelineTaskCard } from './ServiceRequestTimelineTaskCard';

interface ServiceRequestTaskCardProps {
  task: ServiceRequestTaskProps['task'];
  config: ServiceRequestTaskProps['config'];
  state: ServiceRequestTaskProps['state'];
  context: ServiceRequestTaskProps['context'];
  isTimelineView?: boolean;
  displayNumber?: number;
}

export const ServiceRequestTaskCard = (props: ServiceRequestTaskCardProps) => {
  const { context, isTimelineView } = props;
  if (
    [
      ServiceRequestTaskCardDisplayVariant.ONLY_ACTION_BUTTON,
      ServiceRequestTaskCardDisplayVariant.COMPLIANCE_TASK_PREVIEW,
      ServiceRequestTaskCardDisplayVariant.SALES_TAX_FILING_TASK_PREVIEW,
    ].includes(context.variant)
  )
    return <ServiceRequestTaskPreview {...props} />;
  return isTimelineView === false ? (
    <ServiceRequestDefaultTaskCard {...props} />
  ) : (
    <ServiceRequestTimelineTaskCard {...props} />
  );
};
